module.exports = __webpack_public_path__ + "a557ed55df13f5130a298e868b39c848.png";